import { signOut } from 'firebase/auth';
import { terminate, clearIndexedDbPersistence } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { disablePushNotifications } from './pushNotifications';
import { wisStartCache } from './startCache';

// Eén weg voor elk uitloggen (dashboard, beheerpaneel, account verwijderen), zodat er op een
// toestel dat door meer mensen gebruikt wordt niets van het vorige account achterblijft:
//
// 1. Pushmeldingen van dit toestel loskoppelen. Dat moet VÓÓR het uitloggen: het token staat
//    onder het account (users/{uid}/pushTokens) en de beveiligingsregels laten het verwijderen
//    daarna niet meer toe. Anders blijft dit toestel klant- en dienstnamen van het vorige
//    account ontvangen.
// 2. Uitloggen.
// 3. De eigen startcache (localStorage) en de permanente Firestore-cache (IndexedDB, met
//    boekingen, klantnamen en e-mailadressen) wissen. Firestore moet daarvoor eerst beëindigd
//    worden, waarna het niet meer bruikbaar is: de pagina laadt daarom opnieuw (`naar`).
//    Staat dezelfde app in een tweede tabblad open, dan weigert het wissen van IndexedDB en
//    blijft die cache staan (de startcache is dan wel gewist).
// Het uitloggen zelf mag nooit mislukken door een van de opruimstappen.
export async function uitloggenEnOpruimen({ uid, naar = '/', wachtMs = 0 } = {}) {
    if (uid) {
        try {
            await disablePushNotifications(uid);
        } catch (error) {
            console.error('Pushmeldingen loskoppelen bij uitloggen mislukt:', error);
        }
    }

    await signOut(auth);
    wisStartCache();

    try {
        await terminate(db);
        await clearIndexedDbPersistence(db);
    } catch (error) {
        console.warn('Lokale Firestore-cache niet gewist:', error?.message || error);
    }

    if (wachtMs) await new Promise((resolve) => setTimeout(resolve, wachtMs));
    window.location.replace(naar);
}
